// Prefixe telefonice pe tari (aceleasi regiuni ca libphonenumber-js din api.vikart.ro).
// Steagul vine din flag-icon-css: clasa `flag-icon flag-icon-<iso2 cu litere mici>`.

export interface Country {
    iso2: string;
    name: string;
    nameEn: string;
    prefix: string;
}

export const DEFAULT_COUNTRY = 'RO';

// prettier-ignore
export const COUNTRIES: Country[] = [
    { iso2: 'AC', name: 'Insula Ascension', nameEn: 'Ascension Island', prefix: '+247' },
    { iso2: 'AD', name: 'Andorra', nameEn: 'Andorra', prefix: '+376' },
    { iso2: 'AE', name: 'Emiratele Arabe Unite', nameEn: 'United Arab Emirates', prefix: '+971' },
    { iso2: 'AF', name: 'Afganistan', nameEn: 'Afghanistan', prefix: '+93' },
    { iso2: 'AG', name: 'Antigua și Barbuda', nameEn: 'Antigua and Barbuda', prefix: '+1' },
    { iso2: 'AI', name: 'Anguilla', nameEn: 'Anguilla', prefix: '+1' },
    { iso2: 'AL', name: 'Albania', nameEn: 'Albania', prefix: '+355' },
    { iso2: 'AM', name: 'Armenia', nameEn: 'Armenia', prefix: '+374' },
    { iso2: 'AO', name: 'Angola', nameEn: 'Angola', prefix: '+244' },
    { iso2: 'AR', name: 'Argentina', nameEn: 'Argentina', prefix: '+54' },
    { iso2: 'AS', name: 'Samoa Americană', nameEn: 'American Samoa', prefix: '+1' },
    { iso2: 'AT', name: 'Austria', nameEn: 'Austria', prefix: '+43' },
    { iso2: 'AU', name: 'Australia', nameEn: 'Australia', prefix: '+61' },
    { iso2: 'AW', name: 'Aruba', nameEn: 'Aruba', prefix: '+297' },
    { iso2: 'AX', name: 'Insulele Åland', nameEn: 'Åland Islands', prefix: '+358' },
    { iso2: 'AZ', name: 'Azerbaidjan', nameEn: 'Azerbaijan', prefix: '+994' },
    { iso2: 'BA', name: 'Bosnia și Herțegovina', nameEn: 'Bosnia and Herzegovina', prefix: '+387' },
    { iso2: 'BB', name: 'Barbados', nameEn: 'Barbados', prefix: '+1' },
    { iso2: 'BD', name: 'Bangladesh', nameEn: 'Bangladesh', prefix: '+880' },
    { iso2: 'BE', name: 'Belgia', nameEn: 'Belgium', prefix: '+32' },
    { iso2: 'BF', name: 'Burkina Faso', nameEn: 'Burkina Faso', prefix: '+226' },
    { iso2: 'BG', name: 'Bulgaria', nameEn: 'Bulgaria', prefix: '+359' },
    { iso2: 'BH', name: 'Bahrain', nameEn: 'Bahrain', prefix: '+973' },
    { iso2: 'BI', name: 'Burundi', nameEn: 'Burundi', prefix: '+257' },
    { iso2: 'BJ', name: 'Benin', nameEn: 'Benin', prefix: '+229' },
    { iso2: 'BL', name: 'Saint-Barthélemy', nameEn: 'Saint Barthélemy', prefix: '+590' },
    { iso2: 'BM', name: 'Bermuda', nameEn: 'Bermuda', prefix: '+1' },
    { iso2: 'BN', name: 'Brunei', nameEn: 'Brunei', prefix: '+673' },
    { iso2: 'BO', name: 'Bolivia', nameEn: 'Bolivia', prefix: '+591' },
    { iso2: 'BQ', name: 'Insulele Caraibe Olandeze', nameEn: 'Caribbean Netherlands', prefix: '+599' },
    { iso2: 'BR', name: 'Brazilia', nameEn: 'Brazil', prefix: '+55' },
    { iso2: 'BS', name: 'Bahamas', nameEn: 'Bahamas', prefix: '+1' },
    { iso2: 'BT', name: 'Bhutan', nameEn: 'Bhutan', prefix: '+975' },
    { iso2: 'BW', name: 'Botswana', nameEn: 'Botswana', prefix: '+267' },
    { iso2: 'BY', name: 'Belarus', nameEn: 'Belarus', prefix: '+375' },
    { iso2: 'BZ', name: 'Belize', nameEn: 'Belize', prefix: '+501' },
    { iso2: 'CA', name: 'Canada', nameEn: 'Canada', prefix: '+1' },
    { iso2: 'CC', name: 'Insulele Cocos (Keeling)', nameEn: 'Cocos (Keeling) Islands', prefix: '+61' },
    { iso2: 'CD', name: 'Congo - Kinshasa', nameEn: 'Congo - Kinshasa', prefix: '+243' },
    { iso2: 'CF', name: 'Republica Centrafricană', nameEn: 'Central African Republic', prefix: '+236' },
    { iso2: 'CG', name: 'Congo - Brazzaville', nameEn: 'Congo - Brazzaville', prefix: '+242' },
    { iso2: 'CH', name: 'Elveția', nameEn: 'Switzerland', prefix: '+41' },
    { iso2: 'CI', name: 'Côte d’Ivoire', nameEn: 'Côte d’Ivoire', prefix: '+225' },
    { iso2: 'CK', name: 'Insulele Cook', nameEn: 'Cook Islands', prefix: '+682' },
    { iso2: 'CL', name: 'Chile', nameEn: 'Chile', prefix: '+56' },
    { iso2: 'CM', name: 'Camerun', nameEn: 'Cameroon', prefix: '+237' },
    { iso2: 'CN', name: 'China', nameEn: 'China', prefix: '+86' },
    { iso2: 'CO', name: 'Columbia', nameEn: 'Colombia', prefix: '+57' },
    { iso2: 'CR', name: 'Costa Rica', nameEn: 'Costa Rica', prefix: '+506' },
    { iso2: 'CU', name: 'Cuba', nameEn: 'Cuba', prefix: '+53' },
    { iso2: 'CV', name: 'Capul Verde', nameEn: 'Cape Verde', prefix: '+238' },
    { iso2: 'CW', name: 'Curaçao', nameEn: 'Curaçao', prefix: '+599' },
    { iso2: 'CX', name: 'Insula Christmas', nameEn: 'Christmas Island', prefix: '+61' },
    { iso2: 'CY', name: 'Cipru', nameEn: 'Cyprus', prefix: '+357' },
    { iso2: 'CZ', name: 'Cehia', nameEn: 'Czechia', prefix: '+420' },
    { iso2: 'DE', name: 'Germania', nameEn: 'Germany', prefix: '+49' },
    { iso2: 'DJ', name: 'Djibouti', nameEn: 'Djibouti', prefix: '+253' },
    { iso2: 'DK', name: 'Danemarca', nameEn: 'Denmark', prefix: '+45' },
    { iso2: 'DM', name: 'Dominica', nameEn: 'Dominica', prefix: '+1' },
    { iso2: 'DO', name: 'Republica Dominicană', nameEn: 'Dominican Republic', prefix: '+1' },
    { iso2: 'DZ', name: 'Algeria', nameEn: 'Algeria', prefix: '+213' },
    { iso2: 'EC', name: 'Ecuador', nameEn: 'Ecuador', prefix: '+593' },
    { iso2: 'EE', name: 'Estonia', nameEn: 'Estonia', prefix: '+372' },
    { iso2: 'EG', name: 'Egipt', nameEn: 'Egypt', prefix: '+20' },
    { iso2: 'EH', name: 'Sahara Occidentală', nameEn: 'Western Sahara', prefix: '+212' },
    { iso2: 'ER', name: 'Eritreea', nameEn: 'Eritrea', prefix: '+291' },
    { iso2: 'ES', name: 'Spania', nameEn: 'Spain', prefix: '+34' },
    { iso2: 'ET', name: 'Etiopia', nameEn: 'Ethiopia', prefix: '+251' },
    { iso2: 'FI', name: 'Finlanda', nameEn: 'Finland', prefix: '+358' },
    { iso2: 'FJ', name: 'Fiji', nameEn: 'Fiji', prefix: '+679' },
    { iso2: 'FK', name: 'Insulele Falkland', nameEn: 'Falkland Islands', prefix: '+500' },
    { iso2: 'FM', name: 'Micronezia', nameEn: 'Micronesia', prefix: '+691' },
    { iso2: 'FO', name: 'Insulele Feroe', nameEn: 'Faroe Islands', prefix: '+298' },
    { iso2: 'FR', name: 'Franța', nameEn: 'France', prefix: '+33' },
    { iso2: 'GA', name: 'Gabon', nameEn: 'Gabon', prefix: '+241' },
    { iso2: 'GB', name: 'Regatul Unit', nameEn: 'United Kingdom', prefix: '+44' },
    { iso2: 'GD', name: 'Grenada', nameEn: 'Grenada', prefix: '+1' },
    { iso2: 'GE', name: 'Georgia', nameEn: 'Georgia', prefix: '+995' },
    { iso2: 'GF', name: 'Guyana Franceză', nameEn: 'French Guiana', prefix: '+594' },
    { iso2: 'GG', name: 'Guernsey', nameEn: 'Guernsey', prefix: '+44' },
    { iso2: 'GH', name: 'Ghana', nameEn: 'Ghana', prefix: '+233' },
    { iso2: 'GI', name: 'Gibraltar', nameEn: 'Gibraltar', prefix: '+350' },
    { iso2: 'GL', name: 'Groenlanda', nameEn: 'Greenland', prefix: '+299' },
    { iso2: 'GM', name: 'Gambia', nameEn: 'Gambia', prefix: '+220' },
    { iso2: 'GN', name: 'Guineea', nameEn: 'Guinea', prefix: '+224' },
    { iso2: 'GP', name: 'Guadelupa', nameEn: 'Guadeloupe', prefix: '+590' },
    { iso2: 'GQ', name: 'Guineea Ecuatorială', nameEn: 'Equatorial Guinea', prefix: '+240' },
    { iso2: 'GR', name: 'Grecia', nameEn: 'Greece', prefix: '+30' },
    { iso2: 'GT', name: 'Guatemala', nameEn: 'Guatemala', prefix: '+502' },
    { iso2: 'GU', name: 'Guam', nameEn: 'Guam', prefix: '+1' },
    { iso2: 'GW', name: 'Guineea-Bissau', nameEn: 'Guinea-Bissau', prefix: '+245' },
    { iso2: 'GY', name: 'Guyana', nameEn: 'Guyana', prefix: '+592' },
    { iso2: 'HK', name: 'Hong Kong', nameEn: 'Hong Kong', prefix: '+852' },
    { iso2: 'HN', name: 'Honduras', nameEn: 'Honduras', prefix: '+504' },
    { iso2: 'HR', name: 'Croația', nameEn: 'Croatia', prefix: '+385' },
    { iso2: 'HT', name: 'Haiti', nameEn: 'Haiti', prefix: '+509' },
    { iso2: 'HU', name: 'Ungaria', nameEn: 'Hungary', prefix: '+36' },
    { iso2: 'ID', name: 'Indonezia', nameEn: 'Indonesia', prefix: '+62' },
    { iso2: 'IE', name: 'Irlanda', nameEn: 'Ireland', prefix: '+353' },
    { iso2: 'IL', name: 'Israel', nameEn: 'Israel', prefix: '+972' },
    { iso2: 'IM', name: 'Insula Man', nameEn: 'Isle of Man', prefix: '+44' },
    { iso2: 'IN', name: 'India', nameEn: 'India', prefix: '+91' },
    { iso2: 'IO', name: 'Teritoriul Britanic din Oceanul Indian', nameEn: 'British Indian Ocean Territory', prefix: '+246' },
    { iso2: 'IQ', name: 'Irak', nameEn: 'Iraq', prefix: '+964' },
    { iso2: 'IR', name: 'Iran', nameEn: 'Iran', prefix: '+98' },
    { iso2: 'IS', name: 'Islanda', nameEn: 'Iceland', prefix: '+354' },
    { iso2: 'IT', name: 'Italia', nameEn: 'Italy', prefix: '+39' },
    { iso2: 'JE', name: 'Jersey', nameEn: 'Jersey', prefix: '+44' },
    { iso2: 'JM', name: 'Jamaica', nameEn: 'Jamaica', prefix: '+1' },
    { iso2: 'JO', name: 'Iordania', nameEn: 'Jordan', prefix: '+962' },
    { iso2: 'JP', name: 'Japonia', nameEn: 'Japan', prefix: '+81' },
    { iso2: 'KE', name: 'Kenya', nameEn: 'Kenya', prefix: '+254' },
    { iso2: 'KG', name: 'Kârgâzstan', nameEn: 'Kyrgyzstan', prefix: '+996' },
    { iso2: 'KH', name: 'Cambodgia', nameEn: 'Cambodia', prefix: '+855' },
    { iso2: 'KI', name: 'Kiribati', nameEn: 'Kiribati', prefix: '+686' },
    { iso2: 'KM', name: 'Comore', nameEn: 'Comoros', prefix: '+269' },
    { iso2: 'KN', name: 'Saint Kitts și Nevis', nameEn: 'Saint Kitts and Nevis', prefix: '+1' },
    { iso2: 'KP', name: 'Coreea de Nord', nameEn: 'North Korea', prefix: '+850' },
    { iso2: 'KR', name: 'Coreea de Sud', nameEn: 'South Korea', prefix: '+82' },
    { iso2: 'KW', name: 'Kuweit', nameEn: 'Kuwait', prefix: '+965' },
    { iso2: 'KY', name: 'Insulele Cayman', nameEn: 'Cayman Islands', prefix: '+1' },
    { iso2: 'KZ', name: 'Kazahstan', nameEn: 'Kazakhstan', prefix: '+7' },
    { iso2: 'LA', name: 'Laos', nameEn: 'Laos', prefix: '+856' },
    { iso2: 'LB', name: 'Liban', nameEn: 'Lebanon', prefix: '+961' },
    { iso2: 'LC', name: 'Sfânta Lucia', nameEn: 'Saint Lucia', prefix: '+1' },
    { iso2: 'LI', name: 'Liechtenstein', nameEn: 'Liechtenstein', prefix: '+423' },
    { iso2: 'LK', name: 'Sri Lanka', nameEn: 'Sri Lanka', prefix: '+94' },
    { iso2: 'LR', name: 'Liberia', nameEn: 'Liberia', prefix: '+231' },
    { iso2: 'LS', name: 'Lesotho', nameEn: 'Lesotho', prefix: '+266' },
    { iso2: 'LT', name: 'Lituania', nameEn: 'Lithuania', prefix: '+370' },
    { iso2: 'LU', name: 'Luxemburg', nameEn: 'Luxembourg', prefix: '+352' },
    { iso2: 'LV', name: 'Letonia', nameEn: 'Latvia', prefix: '+371' },
    { iso2: 'LY', name: 'Libia', nameEn: 'Libya', prefix: '+218' },
    { iso2: 'MA', name: 'Maroc', nameEn: 'Morocco', prefix: '+212' },
    { iso2: 'MC', name: 'Monaco', nameEn: 'Monaco', prefix: '+377' },
    { iso2: 'MD', name: 'Republica Moldova', nameEn: 'Moldova', prefix: '+373' },
    { iso2: 'ME', name: 'Muntenegru', nameEn: 'Montenegro', prefix: '+382' },
    { iso2: 'MF', name: 'Sfântul Martin', nameEn: 'Saint Martin', prefix: '+590' },
    { iso2: 'MG', name: 'Madagascar', nameEn: 'Madagascar', prefix: '+261' },
    { iso2: 'MH', name: 'Insulele Marshall', nameEn: 'Marshall Islands', prefix: '+692' },
    { iso2: 'MK', name: 'Macedonia de Nord', nameEn: 'North Macedonia', prefix: '+389' },
    { iso2: 'ML', name: 'Mali', nameEn: 'Mali', prefix: '+223' },
    { iso2: 'MM', name: 'Myanmar', nameEn: 'Myanmar', prefix: '+95' },
    { iso2: 'MN', name: 'Mongolia', nameEn: 'Mongolia', prefix: '+976' },
    { iso2: 'MO', name: 'Macao', nameEn: 'Macao', prefix: '+853' },
    { iso2: 'MP', name: 'Insulele Mariane de Nord', nameEn: 'Northern Mariana Islands', prefix: '+1' },
    { iso2: 'MQ', name: 'Martinica', nameEn: 'Martinique', prefix: '+596' },
    { iso2: 'MR', name: 'Mauritania', nameEn: 'Mauritania', prefix: '+222' },
    { iso2: 'MS', name: 'Montserrat', nameEn: 'Montserrat', prefix: '+1' },
    { iso2: 'MT', name: 'Malta', nameEn: 'Malta', prefix: '+356' },
    { iso2: 'MU', name: 'Mauritius', nameEn: 'Mauritius', prefix: '+230' },
    { iso2: 'MV', name: 'Maldive', nameEn: 'Maldives', prefix: '+960' },
    { iso2: 'MW', name: 'Malawi', nameEn: 'Malawi', prefix: '+265' },
    { iso2: 'MX', name: 'Mexic', nameEn: 'Mexico', prefix: '+52' },
    { iso2: 'MY', name: 'Malaysia', nameEn: 'Malaysia', prefix: '+60' },
    { iso2: 'MZ', name: 'Mozambic', nameEn: 'Mozambique', prefix: '+258' },
    { iso2: 'NA', name: 'Namibia', nameEn: 'Namibia', prefix: '+264' },
    { iso2: 'NC', name: 'Noua Caledonie', nameEn: 'New Caledonia', prefix: '+687' },
    { iso2: 'NE', name: 'Niger', nameEn: 'Niger', prefix: '+227' },
    { iso2: 'NF', name: 'Insula Norfolk', nameEn: 'Norfolk Island', prefix: '+672' },
    { iso2: 'NG', name: 'Nigeria', nameEn: 'Nigeria', prefix: '+234' },
    { iso2: 'NI', name: 'Nicaragua', nameEn: 'Nicaragua', prefix: '+505' },
    { iso2: 'NL', name: 'Țările de Jos', nameEn: 'Netherlands', prefix: '+31' },
    { iso2: 'NO', name: 'Norvegia', nameEn: 'Norway', prefix: '+47' },
    { iso2: 'NP', name: 'Nepal', nameEn: 'Nepal', prefix: '+977' },
    { iso2: 'NR', name: 'Nauru', nameEn: 'Nauru', prefix: '+674' },
    { iso2: 'NU', name: 'Niue', nameEn: 'Niue', prefix: '+683' },
    { iso2: 'NZ', name: 'Noua Zeelandă', nameEn: 'New Zealand', prefix: '+64' },
    { iso2: 'OM', name: 'Oman', nameEn: 'Oman', prefix: '+968' },
    { iso2: 'PA', name: 'Panama', nameEn: 'Panama', prefix: '+507' },
    { iso2: 'PE', name: 'Peru', nameEn: 'Peru', prefix: '+51' },
    { iso2: 'PF', name: 'Polinezia Franceză', nameEn: 'French Polynesia', prefix: '+689' },
    { iso2: 'PG', name: 'Papua-Noua Guinee', nameEn: 'Papua New Guinea', prefix: '+675' },
    { iso2: 'PH', name: 'Filipine', nameEn: 'Philippines', prefix: '+63' },
    { iso2: 'PK', name: 'Pakistan', nameEn: 'Pakistan', prefix: '+92' },
    { iso2: 'PL', name: 'Polonia', nameEn: 'Poland', prefix: '+48' },
    { iso2: 'PM', name: 'Saint-Pierre și Miquelon', nameEn: 'Saint Pierre and Miquelon', prefix: '+508' },
    { iso2: 'PR', name: 'Puerto Rico', nameEn: 'Puerto Rico', prefix: '+1' },
    { iso2: 'PS', name: 'Teritoriile Palestiniene', nameEn: 'Palestinian Territories', prefix: '+970' },
    { iso2: 'PT', name: 'Portugalia', nameEn: 'Portugal', prefix: '+351' },
    { iso2: 'PW', name: 'Palau', nameEn: 'Palau', prefix: '+680' },
    { iso2: 'PY', name: 'Paraguay', nameEn: 'Paraguay', prefix: '+595' },
    { iso2: 'QA', name: 'Qatar', nameEn: 'Qatar', prefix: '+974' },
    { iso2: 'RE', name: 'Réunion', nameEn: 'Réunion', prefix: '+262' },
    { iso2: 'RO', name: 'România', nameEn: 'Romania', prefix: '+40' },
    { iso2: 'RS', name: 'Serbia', nameEn: 'Serbia', prefix: '+381' },
    { iso2: 'RU', name: 'Rusia', nameEn: 'Russia', prefix: '+7' },
    { iso2: 'RW', name: 'Rwanda', nameEn: 'Rwanda', prefix: '+250' },
    { iso2: 'SA', name: 'Arabia Saudită', nameEn: 'Saudi Arabia', prefix: '+966' },
    { iso2: 'SB', name: 'Insulele Solomon', nameEn: 'Solomon Islands', prefix: '+677' },
    { iso2: 'SC', name: 'Seychelles', nameEn: 'Seychelles', prefix: '+248' },
    { iso2: 'SD', name: 'Sudan', nameEn: 'Sudan', prefix: '+249' },
    { iso2: 'SE', name: 'Suedia', nameEn: 'Sweden', prefix: '+46' },
    { iso2: 'SG', name: 'Singapore', nameEn: 'Singapore', prefix: '+65' },
    { iso2: 'SH', name: 'Sfânta Elena', nameEn: 'Saint Helena', prefix: '+290' },
    { iso2: 'SI', name: 'Slovenia', nameEn: 'Slovenia', prefix: '+386' },
    { iso2: 'SJ', name: 'Svalbard și Jan Mayen', nameEn: 'Svalbard and Jan Mayen', prefix: '+47' },
    { iso2: 'SK', name: 'Slovacia', nameEn: 'Slovakia', prefix: '+421' },
    { iso2: 'SL', name: 'Sierra Leone', nameEn: 'Sierra Leone', prefix: '+232' },
    { iso2: 'SM', name: 'San Marino', nameEn: 'San Marino', prefix: '+378' },
    { iso2: 'SN', name: 'Senegal', nameEn: 'Senegal', prefix: '+221' },
    { iso2: 'SO', name: 'Somalia', nameEn: 'Somalia', prefix: '+252' },
    { iso2: 'SR', name: 'Suriname', nameEn: 'Suriname', prefix: '+597' },
    { iso2: 'SS', name: 'Sudanul de Sud', nameEn: 'South Sudan', prefix: '+211' },
    { iso2: 'ST', name: 'São Tomé și Príncipe', nameEn: 'São Tomé and Príncipe', prefix: '+239' },
    { iso2: 'SV', name: 'El Salvador', nameEn: 'El Salvador', prefix: '+503' },
    { iso2: 'SX', name: 'Sint Maarten', nameEn: 'Sint Maarten', prefix: '+1' },
    { iso2: 'SY', name: 'Siria', nameEn: 'Syria', prefix: '+963' },
    { iso2: 'SZ', name: 'Eswatini', nameEn: 'Eswatini', prefix: '+268' },
    { iso2: 'TA', name: 'Tristan da Cunha', nameEn: 'Tristan da Cunha', prefix: '+290' },
    { iso2: 'TC', name: 'Insulele Turks și Caicos', nameEn: 'Turks and Caicos Islands', prefix: '+1' },
    { iso2: 'TD', name: 'Ciad', nameEn: 'Chad', prefix: '+235' },
    { iso2: 'TG', name: 'Togo', nameEn: 'Togo', prefix: '+228' },
    { iso2: 'TH', name: 'Thailanda', nameEn: 'Thailand', prefix: '+66' },
    { iso2: 'TJ', name: 'Tadjikistan', nameEn: 'Tajikistan', prefix: '+992' },
    { iso2: 'TK', name: 'Tokelau', nameEn: 'Tokelau', prefix: '+690' },
    { iso2: 'TL', name: 'Timor-Leste', nameEn: 'Timor-Leste', prefix: '+670' },
    { iso2: 'TM', name: 'Turkmenistan', nameEn: 'Turkmenistan', prefix: '+993' },
    { iso2: 'TN', name: 'Tunisia', nameEn: 'Tunisia', prefix: '+216' },
    { iso2: 'TO', name: 'Tonga', nameEn: 'Tonga', prefix: '+676' },
    { iso2: 'TR', name: 'Turcia', nameEn: 'Türkiye', prefix: '+90' },
    { iso2: 'TT', name: 'Trinidad și Tobago', nameEn: 'Trinidad and Tobago', prefix: '+1' },
    { iso2: 'TV', name: 'Tuvalu', nameEn: 'Tuvalu', prefix: '+688' },
    { iso2: 'TW', name: 'Taiwan', nameEn: 'Taiwan', prefix: '+886' },
    { iso2: 'TZ', name: 'Tanzania', nameEn: 'Tanzania', prefix: '+255' },
    { iso2: 'UA', name: 'Ucraina', nameEn: 'Ukraine', prefix: '+380' },
    { iso2: 'UG', name: 'Uganda', nameEn: 'Uganda', prefix: '+256' },
    { iso2: 'US', name: 'Statele Unite ale Americii', nameEn: 'United States', prefix: '+1' },
    { iso2: 'UY', name: 'Uruguay', nameEn: 'Uruguay', prefix: '+598' },
    { iso2: 'UZ', name: 'Uzbekistan', nameEn: 'Uzbekistan', prefix: '+998' },
    { iso2: 'VA', name: 'Vatican', nameEn: 'Vatican City', prefix: '+39' },
    { iso2: 'VC', name: 'Saint Vincent și Grenadinele', nameEn: 'Saint Vincent and the Grenadines', prefix: '+1' },
    { iso2: 'VE', name: 'Venezuela', nameEn: 'Venezuela', prefix: '+58' },
    { iso2: 'VG', name: 'Insulele Virgine Britanice', nameEn: 'British Virgin Islands', prefix: '+1' },
    { iso2: 'VI', name: 'Insulele Virgine Americane', nameEn: 'U.S. Virgin Islands', prefix: '+1' },
    { iso2: 'VN', name: 'Vietnam', nameEn: 'Vietnam', prefix: '+84' },
    { iso2: 'VU', name: 'Vanuatu', nameEn: 'Vanuatu', prefix: '+678' },
    { iso2: 'WF', name: 'Wallis și Futuna', nameEn: 'Wallis and Futuna', prefix: '+681' },
    { iso2: 'WS', name: 'Samoa', nameEn: 'Samoa', prefix: '+685' },
    { iso2: 'XK', name: 'Kosovo', nameEn: 'Kosovo', prefix: '+383' },
    { iso2: 'YE', name: 'Yemen', nameEn: 'Yemen', prefix: '+967' },
    { iso2: 'YT', name: 'Mayotte', nameEn: 'Mayotte', prefix: '+262' },
    { iso2: 'ZA', name: 'Africa de Sud', nameEn: 'South Africa', prefix: '+27' },
    { iso2: 'ZM', name: 'Zambia', nameEn: 'Zambia', prefix: '+260' },
    { iso2: 'ZW', name: 'Zimbabwe', nameEn: 'Zimbabwe', prefix: '+263' },
];

// Romania prima, apoi alfabetic dupa numele in romana
export const SORTED_COUNTRIES: Country[] = COUNTRIES.slice().sort((a, b) => {
    if (a.iso2 === DEFAULT_COUNTRY) return -1;
    if (b.iso2 === DEFAULT_COUNTRY) return 1;

    return a.name.localeCompare(b.name, 'ro');
});

// Tara aleasa implicit cand un prefix e folosit de mai multe tari (ex: lipire "+1...")
const PREFERRED_BY_PREFIX: { [prefix: string]: string } = {
    '+1': 'US',
    '+7': 'RU',
    '+39': 'IT',
    '+44': 'GB',
    '+47': 'NO',
    '+61': 'AU',
    '+212': 'MA',
    '+262': 'RE',
    '+290': 'SH',
    '+358': 'FI',
    '+590': 'GP',
    '+599': 'CW',
};

export function findCountry(iso2: string): Country | undefined {
    return COUNTRIES.find((c) => c.iso2 === iso2);
}

export function findCountryByPrefix(prefix: string): Country | undefined {
    const preferred = PREFERRED_BY_PREFIX[prefix];

    if (preferred) {
        return findCountry(preferred);
    }

    return COUNTRIES.find((c) => c.prefix === prefix);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/commons/countries.ts